import classNames from "classnames";
import React from "react";
import LIFE_ICON from "../../../assets/svg/life.svg";
import styles from "./AllLives.module.scss";

interface IAllLivesProps {
  lives: number;
  direction: "horizontal" | "vertical";
}

const AllLives: React.FC<IAllLivesProps> = ({ lives, direction }) => {
  return (
    <div className={styles.container}>
      <div className={classNames(styles.livesContainer, styles[direction])}>
        {Array.from({ length: lives }, (_, index) => (
          <div key={index} className={styles.life}>
            <img src={LIFE_ICON} alt="Life" className={styles.lifeIcon} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllLives;
